/* eslint-disable no-sequences */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, Fragment } from "react";
import { Button } from "../../../../../components/Component";
const ButtonDisableCP = ({ ...props }) => {
    const [Count, setCount] = useState(0);
    const [isShown, setIsShown] = useState(false);
    const changepage = async (id) => {
        const sendData = {
            CatgTypeId: Number(id),

        }
     /*   //console.log(sendData)*/

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/Getuser', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    localStorage.setItem('userId', data.userId)
                    window.location.pathname = "/CPdashboard"
                    /*props.history.push("/Dashboard")*/
                })


    };



    const getdata = async () => {
        const sendData = {
            YearId: Number(props.year),
            MonthId: Number(props.month),
            Month: String(props.catgtype),
        }
        /*//console.log(sendData)*/

        await fetch(process.env.REACT_APP_API_LINK + 'api/CP/' + props.api, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    setCount(data)
                })


    };

    useEffect(() => {
        getdata()
    }, [props.month, props.year, props.catgtype])

    /*console.log("total", Count.edit + Count.submit)
    console.log("edit", Count.edit )
    console.log("submit", Count.submit)*/
    

    return (
        <Fragment>
            {(
                Count.submit !==0
            ) ? (
                    props.api === "Dgecountcp"
            ) ? (
                    <td>
                        <Button
                            color="primary"
                            onClick={() => (sessionStorage.setItem("StateCP", props.catgtype), window.location.pathname = "/CPStatedashboard")}
                        >
                            View
                            <em class="icon ni ni-eye-fill"></em>
                        </Button>
                    </td>
            ) : (
                     props.api === "Statecountcp" 
            ) ?(
                    <td>
                        <Button 
                                color="primary"
                                onClick={() => (sessionStorage.setItem("RegionCP", props.catgtype), window.location.pathname = "/CPRegionaldashboard")}
                        >
                        View 
                        <em class="icon ni ni-eye-fill"></em>
                       </Button> 
                    </td> 
            ):(
                    <td>
                        <Button 
                            color="primary" 
                            onClick={() => changepage(props.catgtype)}
                        >
                        View 
                        <em class="icon ni ni-eye-fill"></em>
                       </Button> 
                   </td>
            ) : (
                    <td>
                        <Button
                            color="danger"
                            disabled
                            onMouseEnter={() => setIsShown(true)}
                            onMouseLeave={() => setIsShown(false)}>
                            {!isShown ? "View" : null}{isShown && (
                            <div>
                                You cannot View this page.
                            </div>
                        )}
                        <em class="icon ni ni-eye-fill"></em>
                    </Button>
                    </td>
            )}
            

        </Fragment>
    )
};

export default ButtonDisableCP;
